import PropTypes from "prop-types";
import {createNotification} from "app/actions/notifications";
import {destroy as destroyRecord} from "app/requests/admin/pages";
import Check from "components/helpers/check";
import {displayDate} from "lib/ext/string";
import useAppContext from "lib/hooks/use-app-context";

function AdminPagesListRow({onDestroy, record}) {
  const {dispatch} = useAppContext();
  const onDelete = () => {
    if(!window.confirm("Are you sure you want to delete this page?")) { return; }

    destroyRecord(record.id).then(({message, success}) => {
      dispatch(createNotification({content: message, type: success ? "success" : "error"}));

      if(success) { onDestroy(record.id); }
    });
  };

  return (
    <tr>
      <td><Check checked={record.active} /></td>
      <td>{record.rank}</td>
      <td>{record.template}</td>
      <td>{record.name}</td>
      <td>{record.path}</td>
      <td>{displayDate(record.created_at)}</td>
      <td>
        <div className="btn-group" role="group" aria-label="Actions">
          <a className="btn btn-sm btn-green" href={`/${record.path}`} rel="noopener noreferrer" target="_blank">View</a>
          <a className="btn btn-sm btn-blue" href={`/admin/pages/${record.id}`}>Edit</a>
          <button type="button" className="btn btn-sm btn-red" onClick={onDelete}>Destroy</button>
        </div>
      </td>
    </tr>
  );
}

AdminPagesListRow.propTypes = {
  onDestroy: PropTypes.func.isRequired,
  record: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    created_at: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired,
    template: PropTypes.string.isRequired
  }).isRequired
};

export default AdminPagesListRow;
